function init() {
    InitReportNavigation();
}

function InitReportNavigation() {
    if ($('.report-navigation').length) {
  
      // resize top sticky position based on header height
      $(window).on('scroll resize', () => {
        $('.report-navigation').css('top', $('header').outerHeight() - 1 + 'px');
      });
  
      // set active page
      $('.report-navigation a').each(function () {
        if ($(this).attr('href') == window.location.pathname) {
          $(this).addClass('active');
        }
      });
  
    }
  }
  
export {
    init
}